/* has-no-next:
 *
 * Set body.hasNoNext when the current screen title matches a
 * predefined regular expression, and unsets it when does not.
 *
 * Author: Niels Giesen
 *
 * Copyright (C) 2011, 2012 by Berkeley Bridge
 *
 */

import { bb } from "$json";

(function ($) {
  // Regular expression to test absolute screentitles against:
  var re = /^(Einde)$/;

  $(document).on("bb:postHandleData", function (event, data, status, req) {
    if (data && data.jumplist)
      bb.Mode.toggle(
        "hasNoNext",
        data.hasnext == false ||
          $.grep(data.jumplist, function (group) {
            return (
              group.status == "selected" && re.test($.trim(group.screentitle))
            );
          }).length > 0
      );
  });
})(jQuery);
